'use strict';
import React from 'react';
import ViewportMetrics from 'react/lib/ViewportMetrics';

var win = typeof window !== 'undefined' ? window : false;
var FooterBar = React.createClass({
    displayName: 'FooterBar',
    propTypes: {
        isHidden: React.PropTypes.bool
    },
    contextTypes: {
        router: React.PropTypes.func.isRequired
    },
    getInitialState() {
        return {
            scrollPostion: ViewportMetrics.currentScrollTop
        };
    },
    componentDidMount() {
        if (win) {
            win.addEventListener('scroll', this._onPageScroll);
        }
    },
    componentWillUnmount() {
        if (win) {
            win.removeEventListener('scroll', this._onPageScroll);
        }
    },
    _onPageScroll() {
        this.setState({scrollPostion: ViewportMetrics.currentScrollTop});
    },
    render() {
        if (this.state.scrollPostion < 115 || this.props.isHidden) {
            return false;
        }
        return (
            <div className="footerbar">
                <div className="container--centered">
                    {this.props.children}
                </div>
            </div>
        );
    }
});

module.exports = FooterBar;



// WEBPACK FOOTER //
// ./app/components/footerBar/footerBar.jsx